/*
 * @Author: 王枫叶
 * @Date: 2020-09-28 16:52:13
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-12-19 14:39:39
 */
const baseConfig = {
  baseServerUrl: "",
  //playVideoUrl: 'https://tknk.zahokc.cn/',
  playVideoUrl: "/vid/m3u8/", //视频播放
  imgUrl: "https://yuan.dhuqh.com/", //图片预览
  downLoadUrl: "https://yuan.dhuqh.com/" //视频下载
}
if (
  process.env.NODE_ENV === "production" &&
  process.env.VUE_APP_TITLE === "test"
) {
  baseConfig.baseServerUrl = "/api/web/admin"
} else if (process.env.NODE_ENV === "development") {
  // 测试服
  baseConfig.baseServerUrl = "https://yinheht.cestalt.com/api/web/admin"
} else {
  baseConfig.baseServerUrl = "/api/web/admin"
}
export default baseConfig
